import React from "react"
import { Container } from "react-bootstrap"
import HomePage from "../../Components/Home/HomePage"
const HomepageReservation = () => {
  return (
    <Container fluid className="p-0" style={{ height: "100dvh" }}>
      <HomePage />
    </Container>
  )
}
export default HomepageReservation
